import { css } from '@emotion/core';
import { Theme, normalText } from 'features/Theme';
import { PaletteColor } from '@material-ui/core/styles/createPalette';

const variantStyle = (background: PaletteColor) => css`
  background-color: ${background.main};
  color: ${background.contrastText};
`;

export default {
  container: (theme: Theme) => css`
    ${normalText(theme)};
    padding: ${theme.mui.spacing(2)}px 0;
    margin: ${theme.mui.spacing(2)}px 0;
    display: none;
    background-color: ${theme.mui.palette.text.primary};
    color: ${theme.mui.palette.getContrastText(theme.mui.palette.text.primary)};
  `,
  open: css`
    display: flex;
  `,
  success: (theme: Theme) => variantStyle(theme.mui.palette.success),
  error: (theme: Theme) => variantStyle(theme.mui.palette.error),
  info: (theme: Theme) => css`
    background-color: ${theme.mui.palette.primary.main};
    color: ${theme.mui.palette.primary.contrastText};
  `,
  icon: (theme: Theme) => css`
    padding: 0 ${theme.mui.spacing(2)}px;
  `,
  body: (theme: Theme) => css`
    padding-right: ${theme.mui.spacing(2)}px;
  `,
};
